module.exports = "/fonts/Inter_18pt-Regular.ttf";